import { ArrowLeftOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody, CardFooter, CardHeader, Col, Row } from "reactstrap";
import { setLoading } from "../../store/slices/auth";
import { deleteTemplate, getDocument, getDocumentList, getGroups } from "./apiController";
import { CustomButton, showToaster, toasterTypes } from "../../widgets";
import { FieldItem } from "../../widgets/fields";
import useFieldItem from "../../widgets/fields/UseFieldItem";
import CreateDocument from "./CreateDocument";
import Editor from "../Editor/Editor";
import ModalComponent from "../common/Modal/modal";
import { copyData } from "../../utils/Utils";
import Tabs from "../sampleSize/Tabs";
import { TabsData } from "../../utils/TabsData";
import { set } from "lodash";
import TopBar from "../../layouts/postLogin/TopBar";

export default function Documents(props) {
     const navigate = useNavigate();
     const location = useLocation();
     const dispatch = useDispatch();
     const [groups, setgroups] = useState<any | null>([]);
     const [documentList, setDocumentList] = useState<any | null>([]);
     const [documentData, setDocumentData] = useState<any | null>([]);
     const [groupid, SetgroupId] = useState("");
     const [popUpType, setPopUpType] = useState("");
     const [selectedId, setSelectedId] = useState("");
     const [projectData, setprojectData] = useState<any | null>(null);
     const [permission, setPermission] = useState<any | null>({
          create: true,
          edit_doc_content: true,
          delete: true,
          edit_doc: true,
     });
     const [values, fields, handleChange, { validateValues, updateValue }] = useFieldItem({}, {}, { onValueChange });
     const [isEdit, setIsEdit] = useState<any>({})
     const [perPage, setperPage] = useState<number>(15);
     const [pageNo, setpageNo] = useState<number>(1);
     const listInnerRef = useRef<HTMLInputElement>(null);
     const [endScroll, setendScroll] = useState(false);

     /**
    * handle on change values of form elements
    * @param name 
    * @param value 
    * @param values 
    * @param fieldValues 
    * @returns 
    */
     function onValueChange(name, value, values, fieldValues = null) {
          const resetValue = {}
          console.log(values)

          return [{
               ...values,
               ...resetValue,
               [name]: value,
          }]
     }

     /**
    * scroll to bottom get next set of data
    */
     const onScroll = async () => {

          if (listInnerRef.current) {
               const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
               if (-Math.abs(Math.ceil(Math.abs(scrollTop))) === clientHeight - scrollHeight) {
                    try {
                         if (!endScroll) {
                              setpageNo(pageNo + 1)
                              getDocuments(pageNo + 1, perPage)
                         }

                    } catch (e: any) {
                         throw e
                    }
               }
          }
     };

     useEffect(() => {
          if (location.state) {
               let tempState: any = location.state;
               console.log(tempState)
               getDocuments(pageNo, perPage)
               setprojectData(tempState);
               let permArray = {};
               tempState.permissions && tempState.permissions.forEach((obj) => {
                    if (Object.keys(obj)[0] == "Documents") {
                         obj[Object.keys(obj)[0]].forEach((objItem) => {
                              permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0].is_selected
                         })
                         //setPermission(obj[Object.keys(obj)[0]])
                    }
               })
               if (tempState.permissions) {
                    setPermission(permArray)
               }
               console.log(tempState)
               let temp: any = localStorage.getItem("coguide_user");
               if (temp) {
                    temp = JSON.parse(temp);
                    fetchGroups(tempState.TopicID || tempState.TopicCode);
               }
          } else {
               navigate("/project");
          }

     }, [location.state, navigate]);

     /**
   * fetch groups data
   */
     const fetchGroups = async (id) => {
          try {
               dispatch(setLoading(true));
               let tempGroups = await getGroups(id);
               tempGroups?.data.forEach((obj) => {
                    obj.label = obj.name;
                    obj.value = obj.id;
               });
               setgroups(tempGroups?.data || []);
               let groupIndex = tempGroups?.data.findIndex((obj) => obj.is_default);
               if (groupIndex >= 0) {
                    SetgroupId(tempGroups?.data[groupIndex].id);
               } else {
                    SetgroupId(tempGroups?.data[0].id);
               }

               dispatch(setLoading(false));
          } catch (e: any) {
               setgroups([]);
               dispatch(setLoading(false));
          }
     };

     /**
      * get documents list
      */
     const getDocuments = async (pageNum: number = 1, perPage: number = 10, type: any = null) => {
          let tempState: any = location.state;
          try {
               let documentResponse = await getDocumentList(tempState.id, pageNum, perPage);
               console.log(documentResponse)
               if (documentResponse && documentResponse.length > 0) {
                    if (type === 'delete' || type === 'create') {
                         setDocumentList(documentResponse);
                         setpageNo(1);
                         setendScroll(false);
                    } else {
                         const combined = [...documentList, ...documentResponse];

                         // Remove duplicates by 'id'
                         const uniqueDocuments = Array.from(
                              new Map(combined.map(doc => [doc.id, doc])).values()
                         );
                         console.log(uniqueDocuments)
                         setDocumentList(uniqueDocuments);
                    }

               } else {
                    setendScroll(true)
               }

          } catch (error) {
               throw error
          }

     }

     const onClose = () => {
          setPopUpType("")
          setIsEdit({})
          getDocuments(pageNo, perPage)
     }

     const onDelete = async (id) => {
          console.log(id)
          let deleteDoc = await deleteTemplate(id);
          if (deleteDoc) {
               // Clean up local storage tied to this document ID
               localStorage.removeItem(id);
               localStorage.removeItem(id + '_com');
               localStorage.removeItem(id + '_citations');
               localStorage.removeItem(id + '_references');

               getDocuments(pageNo, perPage, 'delete')
               showToaster(toasterTypes.INFO, "Document deleted successfull")
          }
          setPopUpType("")
     }

     /**
      * get document data by its ID
      * @param id 
      */
     const getDocumentData = async (id) => {
          let documentDataResponse = await getDocument(id);
          setDocumentData(documentDataResponse.data)
          console.log(documentDataResponse)
          localStorage.setItem("documentSelected", id)
          if (documentDataResponse) {
               documentDataResponse.data.revision.comment && localStorage.setItem(id + '_com', documentDataResponse && JSON.stringify(documentDataResponse.data.revision.comment))
          }

          let getDocumentDataLocal: any = JSON.parse(localStorage.getItem(id) || "[]")
          if (getDocumentDataLocal && getDocumentDataLocal.length == 0) {
               console.log(documentDataResponse.data.revision.comment)
               documentDataResponse.data.revision.content ? localStorage.setItem(id, documentDataResponse && JSON.stringify(documentDataResponse.data.revision.content)) : localStorage.setItem(id, JSON.stringify({ content: [], type: "doc" }))
               localStorage.setItem("docData", documentDataResponse && JSON.stringify(documentDataResponse.data.revision.content))
          }
          //setPopUpType("editor")
          let tempState: any = location.state;
          //set docInfo to localstorage

          localStorage.setItem("docInfo", JSON.stringify({ docInfo: documentDataResponse.data }))
          navigate('/editor', { state: { docInfo: documentDataResponse.data, data: tempState, docPermission: permission && permission.edit_doc_content } })

     }

     /**
      * get document link
      */
     const getDocumentLink = (id) => {
          let DocLink = `${window.location.href}?docId=${id}`
          copyData(DocLink, true)
          showToaster(toasterTypes.SUCCESS, "Link Copied Successfully");
          // navigate('/editor',{state:"http://localhost:3000/login?docId=66c627efe606d657b27df6bc"})
     }

     /**
      * Edit data
      */
     const onEditAction = (data) => {
          setIsEdit(data)
          setPopUpType("create")
     }

     useEffect(() => {

     }, [permission])

     return (
          <>
               <div className="documents-data-container">
                    {
                         popUpType == "create" &&
                         <CreateDocument projectData={projectData} getDocuments={getDocuments} onClose={onClose} prevData={isEdit} />
                    }

                    {
                         popUpType == "delete" &&
                         <ModalComponent
                              width={"30%"}
                              onClose={() => setPopUpType("")}
                              isOpen={true}
                              header={<b>Delete Document</b>}
                              centered={true}
                              customClass="document-modal"
                              body={
                                   <>
                                        <p>Once deleted, this action cannot be undone. Are you sure you want to delete?</p>

                                   </>
                              }
                              footer={
                                   <CustomButton type={"primary"} text="Delete" onClick={() => onDelete(selectedId)} />
                              }
                         />
                    }

                    <>
                         {/* <Row className='page-header m-0'>
                              <Col className={window.innerWidth > 750 ? "project-title" : "project-title-mob"} md={12}>
                                   <ArrowLeftOutlined style={{ color: "#fff", fontSize: "24px", margin: "0px 10px" }} onClick={() => window.innerWidth > 750 ? navigate("/project") : navigate("/projectmobile")} />
                                   {projectData?.TopicDesc || projectData?.topicdesc}
                              </Col>
                              <Col className='p-0'></Col>
                         </Row> */}
                         <TopBar projectData={projectData} navigate={window.innerWidth > 750 ? "/project" : "/projectmobile"} />

                         <Tabs data={TabsData} selectedTab={9} projectData={projectData} />

                         <div className="documents-data">
                              <Row className="m-3">
                                   <Col className="p-0 d-flex m-0" md={10} xs={12}>
                                        <div className="header mr-4 pt-0">Documents | {documentList && documentList.length}</div>
                                        <FieldItem
                                             name="search"
                                             value={values.search}
                                             onChange={(...e) => handleChange("search", ...e)}
                                             touched={fields.search && fields.search.hasError}
                                             error={fields.search && fields.search.errorMsg}
                                        />
                                   </Col>
                                   <Col className="p-0 d-flex m-0" md={2} xs={12}>
                                        {
                                             permission && permission.create ?
                                                  <CustomButton
                                                       className="mt-2"
                                                       type="alert-primary"
                                                       text="Create"
                                                       onClick={() => setPopUpType("create")}
                                                  ></CustomButton>
                                                  :
                                                  ""}
                                   </Col>
                              </Row>

                         </div>
                         <div className="documents-container" onScroll={() => onScroll()} ref={listInnerRef}>
                              <div className="documents-list-container m-3" >

                                   {
                                        documentList && documentList.map((item, i) => {

                                             return (
                                                  <Card className="document-card" key={i}>
                                                       <CardHeader>
                                                            <Row>
                                                                 <Col md="9">
                                                                      <span className="title">{item.name}</span>
                                                                 </Col>
                                                                 <Col md="3">
                                                                      V<span className="version">{item.versions_count || 0}</span>
                                                                 </Col>
                                                            </Row>
                                                       </CardHeader>
                                                       <CardBody>
                                                            <span className="description">{item.desc}</span>
                                                       </CardBody>
                                                       <CardFooter className="footer-card">
                                                            <div className="document-actions">
                                                                 <span className="mr-3">
                                                                      <span className="apply-txt" style={{ color: "var(--primary-color, #006BD9)", cursor: "pointer" }} onClick={() => getDocumentData(item.id)} >View</span>
                                                                 </span>
                                                                 {
                                                                      permission && permission.edit_doc ?
                                                                           <span className="mr-3">
                                                                                <i className="icon icon-edit" onClick={() => onEditAction(item)}></i>
                                                                           </span>
                                                                           :
                                                                           ""}
                                                                 {
                                                                      permission && permission.delete ?
                                                                           <span className="mr-3">
                                                                                <i className="icon icon-delete" onClick={() => { setSelectedId(item.id); setPopUpType("delete") }}></i>
                                                                           </span> : ""
                                                                 }


                                                            </div>
                                                       </CardFooter>
                                                  </Card>
                                             )
                                        })
                                   }
                              </div>
                         </div>
                    </>

               </div>
          </>
     )
}